import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './PricingCompactCard.module.scss'

export interface PricingCompactCardProps {
  savings: string
  condition: string
  hideOnMobile?: boolean
  hideOnDesktop?: boolean
  hasBackground?: boolean
}

export function PricingCompactCard({
  savings,
  condition,
  hideOnMobile = false,
  hideOnDesktop = false,
  hasBackground = false,
}: PricingCompactCardProps): ReactNode {
  const iconUrl = '/icons/ab397/dollar-circle.svg'
  return (
    <div
      className={classNames(styles.PricingCompactCard, {
        [styles.PricingCompactCard___hideOnMobile]: hideOnMobile,
        [styles.PricingCompactCard___hideOnDesktop]: hideOnDesktop,
        [styles.PricingCompactCard___hasBackground]: hasBackground,
      })}
    >
      <img
        className={styles.PricingCompactCard__icon}
        src={iconUrl}
        alt="Dollar icon"
        loading="lazy"
      />
      <div className={styles.PricingCompactCard__text}>
        <span className={styles.PricingCompactCard__savings}>{savings}</span>{' '}
        <span className={styles.PricingCompactCard__condition}>{condition}</span>
      </div>
    </div>
  )
}
